import { Service } from '@/tools'
export class AuditDataFormService<T extends TCommodity.AuditDataForm> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TCommodity.AuditDataForm}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }
  // 查询sku是否在审核中 /api/commodity/auditDataForm/v1/querySkuIsItUnderReview
  querySkuIsItUnderReview = <K extends T['ApiQuerySkuIsItUnderReview']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiQuerySkuIsItUnderReview', data)
}
